module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/redux-act-async/~/core-js/library/modules/_library.js
// module id = 2116
// module chunks = 0